import React from 'react';
import { RichText } from '../../../../components';
import styles from './styles.module.scss';

interface Props {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  content?: any | null;
  index: number;
  setActiveIndex?: React.Dispatch<React.SetStateAction<number>>;
}

export const StickyImageScrollContent: React.FC<Props> = ({
  content,
  index,
  setActiveIndex,
}) => {
  const containerRef = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    const handleScroll = () => {
      if (containerRef.current) {
        const rect = containerRef.current.getBoundingClientRect();
        const windowHeight = window.innerHeight;
        const { top, bottom } = rect;

        if (top < (windowHeight / 2) && bottom > (windowHeight / 2)) {
          if (setActiveIndex) {
            setActiveIndex(index);
          }
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [containerRef, index, setActiveIndex]);

  return (
    <div
      ref={containerRef}
      className={styles.container}
    >
      <RichText
        className={styles.richText}
        data={content}
      />
    </div>
  );
};
